import InconsolataVariable from "/fonts/Inconsolata-Variable.woff2?url"

export function Fonts() {
    return (
        <>
            <style>{`
                @font-face {
                    font-display: swap;
                    font-family: 'Inconsolata';
                    src: url(${InconsolataVariable}) format('woff2');
                    font-weight: 100 900;
                }
            `}</style>
        </>
    )
}

export {
    InconsolataVariable,
}